export type AIConvoPanelView = 'settings' | 'agents' | 'history';

export interface AIConvoPanelPage {
    view: AIConvoPanelView;
    title?: string;
}

export const PAGE_TITLES: Partial<Record<AIConvoPanelView, string>> = {
    agents: 'AI.SIDE_PANEL.SETTINGS.AGENTS_PANEL_TITLE',
    history: 'AI.SIDE_PANEL.SETTINGS.HISTORY_PANEL_TITLE',
};
